import { withNamespaces } from "react-i18next";
import {
    Button,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";

const DeletionTaskModal = function ({
    isOpen,
    close,
    t,
    taskId,
    acceptDeletion,
    inProcess
}) {
    return (
        <Modal
            size="lg"
            scrollable={true}
            isOpen={isOpen}
            backdrop="static"
        >
            <ModalHeader toggle={close}>
                {t("Delete Task")}
            </ModalHeader>

            <ModalBody>
                <AvForm className="needs-validation">
                    <Row>
                        <Label>{t("Are you sure?")}</Label>
                    </Row>

                    <ModalFooter>
                        <Button
                            color="primary"
                            className="waves-effect waves-light"
                            type="submit"
                            onClick={() => {
                                acceptDeletion(taskId);
                            }}
                            disabled={inProcess}
                        >
                            {inProcess ? (
                                <Spinner 
                                    size='sm'
                                    color='white'
                                    className='me-1'
                                />
                            ) : t("Delete")}
                        </Button>
                        <Button
                            color="secondary"
                            className="waves-effect waves-light"
                            type="button"
                            onClick={close}
                            disabled={inProcess}
                        >
                            {t("Cancel")}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(
    DeletionTaskModal
);
